export const CAPITAL_EXPLORER_CALLOUT_VISIBLE =
  "capitalExplorer.calloutVisible";
export const CAPITAL_EXPLORER_USER_GUIDING_VISIBLE =
  "capitalExplorer.userGuidingVisible";

export const GLOSSARY_URL =
  "https://uploads-ssl.webflow.com/5e2ed8158c2b1767c8d0628c/64789f7b15f073340eb5de72_Glossary%20-%20Adventure%20Finance.pdf";
